import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, AfterContentChecked, AfterContentInit, EventEmitter, Output, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



import { AppUsersDocsService } from '../../core/services/appUsersDocs.service';;
import { AppUsuario } from '../../core/models/appUsuario.model';
import { AppUsuarioService } from '../../core/services/appUsuarioService.service';
import { AppDocumentos } from '../../core/models/appDocumentos.model';
import { AppDocumentosService } from '../../core/services/appDocumentos.service';
import { HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../core/helper/ListFormBase';


@Component({
  selector: 'app-docs-users-dialog',
  templateUrl: './docs-users-dialog.component.html',
  styleUrls: ['./docs-users-dialog.component.scss'],
  providers: [AppUsersDocsService, AppUsuarioService, AppDocumentosService]
})
export class DocsUsersDialogComponent extends ListFormBase<AppUsuario> implements AfterViewInit {

  panelIcon = 'event_available'; // Material icon
  panelTitle = 'Solicitud';
  panelDescription = 'Observaciones de la solicitud';
  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;

  usersSelected: any[];
  availableUsers: any[] = [];


  constructor(
    protected _modelService: AppUsuarioService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected userDocsService: AppUsersDocsService,

    protected docsService: AppDocumentosService,
    public dialogRef: MatDialogRef<DocsUsersDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    super(_modelService, _router, _route, _messageDialog, AppUsuario);
    this.isCrud = false;
    this.usersSelected = [];
  }



  ngAfterViewInit(): void {
    setTimeout(() => {
      // this.getDataSource();
      this._modelService.getAllForSelectByCompanyNif(this.data.company).subscribe(
        response => {
          this.dataSource = response
        },
        error => {
          console.error('An error occurred:', error);
        }
      );
    });
  }

  onDataGridContentReady(event: any) {
    if (this.data.type == 'User') {

      this.data.data.forEach(element => {
        this.usersSelected.push(element.user1);
      });
      //seleccionar usuarios 
      this.dataGrid.instance.selectRows(this.usersSelected, false)

    } else {
      null
    }

  }


  closePopUp(change) {
    if (change) {

      this.dialogRef.close(this.availableUsers);
    } else {
      this.dialogRef.close(this.data.data);
    }
  }



  onSelectionChanged(event) {
    this.availableUsers = event.selectedRowsData
  }


  onSubmitUser() {
    this.closePopUp(true)
  }

}
